import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import Header from "../components/Header";
import PixPayment from "../components/PixPayment";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Clock, LogOut, ArrowLeft } from "lucide-react";

const LABELS = { plan_associado: "Associado Ativo (R$ 39,90)" };

export default function AwaitingActivation() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const isUpgrade = !!user?.upgrade_status;
  const isCadastro = user?.activation_status && user.activation_status !== "approved";

  useEffect(() => {
    if (user && !isCadastro && !isUpgrade) { navigate("/dashboard"); }
  }, [user, isCadastro, isUpgrade, navigate]);

  if (!user) return null;

  const isRenewal = !!user.renewal_pending;
  const label = LABELS[isUpgrade ? user.requested_plan : user.plan] || "-";
  const heading = isRenewal ? "Reativação do plano" : isUpgrade ? "Upgrade de plano" : "Ativação pendente";
  const message = isRenewal
    ? `Para reativar o ${label}, pague o PIX abaixo.`
    : isUpgrade
      ? `Para ativar o upgrade para ${label}, pague o PIX abaixo.`
      : `Para ativar seu ${label}, pague o PIX abaixo.`;

  return (
    <div className="min-h-screen">
      <Header />
      <div className="pt-28 pb-16 max-w-2xl mx-auto px-4">
        <Card className="p-6 sm:p-8 gold-border">
          <div className="flex items-center gap-3">
            <Clock className="h-8 w-8 gold-text" />
            <div>
              <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground" data-testid="awaiting-heading">{heading}</div>
              <h1 className="font-display text-2xl font-bold">
                Olá, <span className="gold-text">{user.name.split(" ")[0]}</span>
              </h1>
            </div>
          </div>

          <p className="mt-6 text-sm">{message} O plano é ativado automaticamente assim que o pagamento for confirmado.</p>

          <PixPayment />

          <div className="mt-8 pt-6 border-t border-border flex justify-between items-center gap-3">
            <div className="text-xs text-muted-foreground">
              Status: <b className="text-foreground">Aguardando pagamento</b>
            </div>
            <div className="flex gap-2">
              {((isUpgrade && user.activation_status === "approved") || user.account_type === "buyer") && (
                <Button variant="outline" size="sm" onClick={() => navigate("/dashboard")} data-testid="back-dashboard">
                  <ArrowLeft className="h-4 w-4 mr-2" /> Voltar
                </Button>
              )}
              <Button variant="outline" size="sm" onClick={() => { logout(); navigate("/"); }} data-testid="awaiting-logout">
                <LogOut className="h-4 w-4 mr-2" /> Sair
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
